import React, { useEffect, useState } from 'react';
import { Provider } from './AuthContext';
import { useAuth0,  } from '@auth0/auth0-react';
import { useCurrentUserLazyQuery, User, UserStatus } from '../../shared/types/generated';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loading } from '../../shared/components/Loading';
import { Error } from '../error/Error';
import { useSetupAuth0Token } from './auth-hooks';
import { MetaApiCloudProvider } from '../meta-api-cloud/MetaApiCloudProvider';
import { AuthBlock } from './AuthBlock';

type AuthProviderProps = {
  children?: React.ReactNode;
};

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const { isLoading: loadingToken, isTokenReady } = useSetupAuth0Token();
  const navigate = useNavigate();
  const [loadingUser, setLoadingUser] = useState(true);
  const [user, setUser] = useState<User | null>(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get('error');
  const errorDescription = params.get('error_description');

  const [currentUser] = useCurrentUserLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setUser(data.currentUser);
      setLoadingUser(false);
      console.log({ data });

      if (data.currentUser?.status === UserStatus.Inactive) return navigate('/auth/inactive');

      if (location.state && location.state.redirectTo) return navigate(location.state.redirectTo);

      if (!data.currentUser?.meta_api_cloud_account) return navigate('/onboarding');

    },
    onError: (e) => {
      console.log(e);
    },
  });

  useEffect(() => {
    if (isTokenReady) {
      currentUser();
    }
  }, [currentUser, isTokenReady]);

  const refetch = (): void => {
    currentUser();
  };

  console.log({ error, errorDescription });

  if(error && errorDescription === 'user is blocked') {
    return <AuthBlock />;
  }

  if (error) {
    return <Error />;
  }


  if (!isAuthenticated) {
    navigate('auth', { state: { redirectTo: window.location.href } });
  }

  if (isLoading || loadingUser || loadingToken) return <Loading>Loading user...</Loading>;

  const values = {
    isAuthenticated,
    isLoading,
    user,
    refetch,
  };


  return <Provider value={values}>
    <MetaApiCloudProvider>{children}</MetaApiCloudProvider>
  </Provider>;
};
